// 证券导出（仅后台使用：管理员 / 已授权图片管理的代理商）。前台用户没有导出功能，原来的用户端“全部导出”已删除。
import api from './api';
import { downloadFile } from './share';

// 证券“批量导出”：默认只导还没导出过的最终图；可包含已导出过的。压缩包里只有最终图，不含单独的字段白底图。
// 导出发完后服务端才记账（标记已导出 + 生成一个待清理的导出批次），中途断了不会误标。
// body 可带 userId / date / includeExported。返回 { ok, count, exportId }
export async function downloadPuzzleBatchExport(body = {}) {
  try {
    const res = await api.post('/puzzle/export', body, { responseType: 'arraybuffer', timeout: 10 * 60 * 1000 });
    const count = res.headers['x-puzzle-export-count'];
    const exportId = res.headers['x-puzzle-export-id'] || null;
    const stamp = new Date().toISOString().slice(0, 10);
    downloadFile({ filename: `证券导出${count ? `-${count}条` : ''}-${stamp}.zip`, text: res.data, mime: 'application/zip' });
    return { ok: true, count: count ? Number(count) : null, exportId };
  } catch (err) {
    let msg = '导出失败';
    try {
      const buf = err.response?.data;
      if (buf && buf.byteLength) msg = JSON.parse(new TextDecoder('utf-8').decode(buf)).error || msg;
    } catch {}
    return { ok: false, error: msg };
  }
}
